import { gate } from 'hub-http/gates';
import { useGetIsUngated } from '../../auth/hooks/useGetIsUngated';
import { useMemo } from 'react';

/**
 * The gate Copilot:V2 represents the new Copilot V2 experience.
 *
 * This new experience includes using Websockets instead of SSE for our FE and BE communication
 * Websockets are powered by Ably so anything 'Ably' related will mean it's related to Websockets
 *
 * Part of the transition to Websockets includes transitioning to new RPC calls that is powered by our new BE architecture.
 */
export const useIsUngatedForCopilotV2 = () => {
  const isUngated = useGetIsUngated();
  return useMemo(() => isUngated(gate('Copilot:V2')), [isUngated]);
};